module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2j9Bu1gNTQf7nGo1VA4R5A-32e5d3d21c40d9c3c9153aec34373b61.jpg";